const productContent = document.getElementsByClassName(
  'product__content'
)[0];
const sprStarRating =
  document.getElementsByClassName('spr-starrating')[0];

if (!productContent && !sprStarRating) {
  if (productContent.classList.contains('text-center')) {
    sprStarRating.style.justifyContent = 'center';
  } else if (productContent.classList.contains('text-right')) {
    sprStarRating.style.justifyContent = 'flex-end';
  } else if (productContent.classList.contains('text-left')) {
    sprStarRating.style.justifyContent = 'flex-start';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const selectedSwatch = document.querySelector('.product__swatch--color.is-active');
  console.log(selectedSwatch);
  if (selectedSwatch) {
    let selectedSwatchTitle = selectedSwatch.getAttribute('title');
    document.querySelector('.js-selected-swatch').textContent = selectedSwatchTitle;
  }

  // if active swatch changes, update the selected swatch text
  const swatches = document.querySelectorAll('.product__swatch--color');
  swatches.forEach((swatch) => {
    swatch.addEventListener('click', function () {
      let selectedSwatchTitle = swatch.getAttribute('title');
      document.querySelector('.js-selected-swatch').textContent = selectedSwatchTitle;
    });
  });
});
